import React from 'react';
import styles from '../../../stylesheets/management_site/tenantForm.module.scss';

const MDCTextField = ({
  label,
  name,
  id,
  type = 'text',
  size,
  className = '',
  defaultValue = '',
  required = false,
  floatAbove = false,
  ...props
}) => {
  const labelClasses = `mdc-floating-label${floatAbove ? ' mdc-floating-label--float-above' : ''}`;

  return (
    <div className={`pm-flex pm-flex-col ${styles.textFieldContainer}`}>
      <div className="mdc-form-field mdc-form-field--align-end">
        <div
          className="mdc-text-field pm-margin-none"
          data-mdc-auto-init="MDCTextField"
        >
          <label htmlFor={id} className={labelClasses}>
            {label}
          </label>
          <input
            type={type}
            name={name}
            id={id}
            className={`mdc-text-field__input ${className}`}
            defaultValue={defaultValue}
            required={required}
            size={size}
            {...props}
          />
        </div>
      </div>
    </div>
  );
};

export default MDCTextField;
